import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'rnpl-data-import-sales-price-modal',
  templateUrl: './data-import-sales-price-modal.component.html'
})
export class DataImportSalesPriceModalComponent {

  constructor(
    public readonly dialogRef: MatDialogRef<DataImportSalesPriceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      salesPriceListControl: FormControl
    }
  ) {
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });
  }

  public submit(): void {
    this.dialogRef.close(true);
  }

}

